export enum DocumentTypes {
    I = 'Invoice',
    M = 'Credit Memo',
    S = 'Statement',
    V = 'Service Charge',
    D = 'Debit Memo',
    L = 'Dunning Letter',
    F = 'Finance Charge'
  }